import React, { useEffect } from 'react';

import { MDText } from 'i18n-react';

import { useQuery } from 'Utilities/hooks';

import { getKeeperAuth } from 'Services/privateApis';

import PageLoader from 'Components/transitions/PageLoader/PageLoader';
import { Content } from 'LegacySBCRA/Content/Content';

import { useGeneralErrorToast } from '../../../../vehicleProfiling/VehicleProfiling.hooks';
import { INCODE_ANALYTICS } from '../IncodeSDKPage/IncodeAnalytics';

import texts from './VerifyYourIdentityPage.json';

import styles from './VerifyYourIdentityPage.module.scss';

const LocalT = new MDText(texts);

const ANALYTICS_PARAMS = {
  action: 'get_keeper_auth',
  backend_entity: 'keeper_auth',
  backend_service: 'incode_documents_verification',
};

export const VerifyYourIdentityPage = () => {
  const id = useQuery('id');

  const { showErrorToast } = useGeneralErrorToast();

  useEffect(() => {
    if (!id) {
      return () => {};
    }

    const controller = new AbortController();

    getKeeperAuth(id, controller)
      .then((response) => {
        INCODE_ANALYTICS.API_TRIGGERED({
          ...ANALYTICS_PARAMS,
          success: true,
          value: id,
        });

        globalThis.location.href = response.data.link;
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          return;
        }

        INCODE_ANALYTICS.API_TRIGGERED({
          ...ANALYTICS_PARAMS,
          success: false,
          value: id,
        });

        globalThis?.Sentry?.captureException?.(error, {
          tags: { feature: 'KeeperAuth' },
        });

        showErrorToast();
      });

    return () => {
      controller.abort();
    };
  }, [id, showErrorToast]);

  return (
    <Content className={styles.wrapper}>
      <PageLoader className={styles.loader} />
      <div className={styles.content}>
        <h2>{LocalT.translate('heading')}</h2>
        <p data-thc-style-override>{LocalT.translate('content')}</p>
      </div>
    </Content>
  );
};
